import styled from "styled-components";
import fonts, { fontWeights } from "styles/fonts";

export const StyledTableContainer = styled.section`
  flex: 0 1 100vw;
  width: 100%;
  margin-bottom: 50px;
  position: relative;
`;

export const WarningWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  font-size: ${fonts.medium};
  font-weight: ${fontWeights.bold};

  padding-bottom: 50px;
`;
